import { FirebaseActionTypes, FirebaseActions } from '@web_opxp/features';

export const onBannerClickTrackingAction: (isPremium: boolean) => FirebaseActionTypes.IAnalyticsEventAction = (
  isPremium
) => {
  return FirebaseActions.analyticsEventAction({
    eventName: 'v_banner_clicked',
    parameters: [
      { key: 'Location', value: 'Dashboard' },
      { key: 'Campaign', value: 'Med' },
      { key: 'Role', value: isPremium ? 'Premium' : 'Freemium' },
    ],
  });
};

export const onBannerCloseTrackingAction: (isPremium: boolean) => FirebaseActionTypes.IAnalyticsEventAction = (
  isPremium
) => {
  return FirebaseActions.analyticsEventAction({
    eventName: 'v_banner_closed',
    parameters: [
      { key: 'Location', value: 'Dashboard' },
      { key: 'Campaign', value: 'Med' },
      { key: 'Role', value: isPremium ? 'Premium' : 'Freemium' },
    ],
  });
};
